import { Fragment } from "react";
import Layout from "../layouts/layout";
import ReferHeroBlock from "../blocks/Refer/HeroBlock";
import ReferSummaryBlock from "../blocks/Refer/ReferSummaryBlock";
import ReferBenefitsTabs from "../blocks/Refer/ReferBenefitsTabs";
import ReferVideoBlock from "../blocks/Refer/ReferVideoBlock";

const metaTitle = "Business Referral Program - Heights Finance";
const metaDescription =
  "Heights Finance Business customers, you can earn money by referring your customers to us for their personal loan needs. Ask us about the referral program today!";
const metaKeywords = "";

const Refer = () => {
  return (
    <Layout>
      <div
        sx={{
          overflow: "hidden",
        }}
      >
        <ReferHeroBlock />
        <ReferSummaryBlock />
        <ReferBenefitsTabs />
        <ReferVideoBlock />
      </div>
    </Layout>
  );
};

export default Refer;

export function Head() {
  return (
    <Fragment>
      <title>{metaTitle}</title>
      <meta name="description" content={metaDescription} />
      <meta name="keywords" content={metaKeywords} />
    </Fragment>
  );
}
